import React from 'react'
import PropTypes from 'prop-types'

import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import Toolbar from 'material-ui/Toolbar'

import {Close as CloseIcon} from 'material-ui-icons'

const styles = {
  root: {
    width: '100%',
  },
  flex: {
    flex: 1,
  },
  actionButton: {
  },
}

let ItemToolbar = ({title, onClose, onMore, compact, classes}) => (
  <Toolbar disableGutters className={classes.root}>
    <Typography type="title" component="h2" className={classes.flex}>
      {title}
    </Typography>
    { !compact && 
      <IconButton color="primary" aria-label="Close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    }
    { compact && 
      <Button dense aria-label="Menu" onClick={onMore} className={classes.actionButton}>
        More
      </Button>
    }
  </Toolbar>
)

ItemToolbar.propTypes = {
  title: PropTypes.string,
  compact: PropTypes.bool.isRequired,
  onMore: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ItemToolbar)


// WEBPACK FOOTER //
// ./src/components/ItemToolbar.js